import { useState, useEffect } from "react";
import { useCreateCollection } from "@/hooks/api/useCollections";
import { NewCollectionDetailsBottomSheet } from "./NewCollectionDetailsBottomSheet";

interface CreateCollectionFlowProps {
  open: boolean;
  onClose: () => void;
  onCollectionCreated: (id: string) => void;
}

export const CreateCollectionFlow = ({
  open,
  onClose,
  onCollectionCreated,
}: CreateCollectionFlowProps) => {
  const [detailsOpen, setDetailsOpen] = useState(open);
  const createCollection = useCreateCollection();

  useEffect(() => {
    if (open) {
      setDetailsOpen(true);
    }
  }, [open]);

  const handleSubmit = async (data: {
    name: string;
    isPrivate: boolean;
    isPaidSubscriberOnly: boolean;
  }) => {
    try {
      const created = await createCollection.mutateAsync({
        name: data.name,
        isPrivate: data.isPrivate,
        isPaidSubscriberOnly: data.isPaidSubscriberOnly,
      });
      onCollectionCreated(created.id);
    } catch (error) {
      console.error("Failed to create collection", error);
    }
  };

  return (
    <NewCollectionDetailsBottomSheet
      open={detailsOpen}
      onClose={() => {
        setDetailsOpen(false);
        onClose();
      }}
      onSubmit={handleSubmit}
      isLoading={createCollection.isPending}
    />
  );
}; 